"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-format/src/identity.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-format/src/identity.js
// module chunks = 1